import React, { useState, useEffect } from 'react';
import { 
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
} from '@mui/material';
import { getActivityLogs } from '../api/apiService';

const HistoryLogs = () => {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const data = await getActivityLogs();
        setLogs(data);
      } catch (error) {
        console.error('Error fetching logs:', error);
      }
    };
    fetchLogs();
  }, []);
  return (
    <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Timestamp</TableCell>
                    <TableCell>User Email</TableCell>
                    <TableCell>Action</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {logs.map((log) => (
                    <TableRow key={log.id}>
                        <TableCell>{new Date(log.timestamp).toLocaleString()}</TableCell>
                        <TableCell>{log.userEmail}</TableCell>
                        <TableCell>{log.action}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
  )
}

export default HistoryLogs